export interface ProjectSearchParams {
  name: string;
  order: string;
  page: number;
}

export interface Project {
  id: string
  accountId: string
  avatar: { tag: string, url: string }
  coverImage?: { id: null | string, url: string }
  createdAt: string
  createdBy: string
  lastModif: string
  lastPublish: string
  metaTitle: string
  status: 'published' | 'unpublished'
  title: string
  toolKey: string
  toolName : string

  // deprecated:
  // cover_image: { id: null, url: string }
  // created_at: string
  // created_by: string
}

export interface ProjectState {
  query:string;
  page:string;
  sort: string;
  perPage:string;
  type:string;
  labels:[];
  tools:[];
  toolObjects:any;
  labelObjects:any;
}

export interface ZprCheckboxListItem {
  name: string;
  id: string;
  selected: boolean;
  imgUrl?: string;
}

export interface Team {}

export interface CardInfo {
  cardId: number;
  lastFour: number;
  type: string;
}

export type FieldType = 'text' | 'email' | 'number';

export interface Label {
  count: number;
  name: string;
  createdAt: string;
  statsKey: string;
  uid: string;
}

export interface ApiLabel {
  count: number;
  name: string;
  created_at: string;
  stats_key: string;
  uid: string;
  selected: boolean;
}

export interface ToolData {
  id: string
  name: string
  selected: boolean
}

export interface LabelData {
  id: string
  name: string
  created_at?: string
  projectCount?: number
  selected: boolean
}

export interface ItemAction {
  text: string
  callback: (ev: Event, item: ZprCheckboxListItem) => void
}


export interface Trigger {
  code: number;
  lastPublish: string;
  updatedAt: string;
  shortUid: null;
  skin: number;
  id: string;
  style: number;
  pngStatus: number;
  forecolor: string;
  backcolor: string;
  type: number;
  status: number;
  shareEnabled: boolean;
  svgUrl: string;
  name: string;
  createdAt: string;
  pngUrl: string;
  isMain: boolean;
  launchType: number;
  extraData: object;
  qsParams: string;
  typeDisplay: string;
  url: string;
}

export interface ApiTrigger {
  code: number;
  last_publish: string;
  updated_at: string;
  short_uid: null;
  skin: number;
  owner: number;
  id: string;
  style: number;
  png_status: number;
  base_url: string;
  forecolor: string;
  centre_widget: null;
  backcolor: string;
  type: number;
  status: number;
  account_id: string;
  share_enabled: boolean;
  is_private: boolean;
  svg_url: string;
  name: string;
  created_at: string;
  project: number;
  backg_sound: null;
  png_url: string;
  is_main: boolean;
  launch_type: number;
  extra_data: object;
  qs_params: string;
  codekey: string;
  type_display: string;
  url: string;
}

export type GetSearchData = (input?: string) => void;

export enum ToastContrast{
  undefined = 'undefined',
  default = 'default',
  high =  'high',
}
export enum ToastSize{
  default = 'default',
  mini = 'mini',
}

export enum ToastType{
  success = 'success',
  warning = 'warning',
  error =  'error',
  info = 'info',
}

export interface Toast {
  contrast: ToastContrast;
  size: ToastSize;
  type: ToastType;
  message: string;
  timeout: number;
}

export enum InputStatus {
  default = 'default',
  processing = 'processing',
  finished = 'finished',
  error = 'error'
}

export enum ButtonSize {
  small = 'btn-small',
  medium = 'btn-medium',
  large = 'btn-large'
}

export enum ButtonType {
  primary = 'btn-primary',
  secondary = 'btn-secondary',
  ghost = 'btn-ghost',
  link = 'btn-link',
  dots = 'btn-dots',
}


export * from './imgrec';